import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'

import EmpleosRelacionados from '../../../../../pages/ficha-aviso/components/empleos-relacionados'

import { Separador } from './mixins'

const Component = ({ avisosSimilares, loading }) => {
  if (!avisosSimilares && !loading) {
    return null
  }

  return (
    <Row>
      <Col>
        <EmpleosRelacionados />
        <Separador />
      </Col>
    </Row>
  )
}

const states = ({ activeAvisoStore }) => {
  const { avisosSimilares, loading } = activeAvisoStore
  return {
    avisosSimilares,
    loading,
  }
}

export default connect(states)(Component)
